module.exports = __webpack_public_path__ + "static/media/aggjakten2026_hcp.73e21870.jpg";